import axiosInstance from "../axiosInstance";
import { Role } from "../types/types";

/** 로그인 사용자의 현재 메뉴 권한 목록 조회 */
export async function fetchUserRoles(): Promise<Role[]> {
  const res = await axiosInstance.get("/api/v1/auth/user/roles");
  const d = res.data as { data?: Role[] };
  return d.data ?? [];
}
